import React from 'react';
import { useTranslation } from 'react-i18next';

interface HeroProps {
  onStartTrial: () => void;
  onLearnMore: () => void;
}

const Hero: React.FC<HeroProps> = ({ onStartTrial, onLearnMore }) => {
  const { t } = useTranslation('common');

  return (
    <section className='hero section'>
      <div className='hero-background'></div>
      <div className='container-mobile hero-container full-width-mobile'>
        <div className='hero-content'>
          <h1 className='hero-title'>
            {t('hero.title')}
          </h1>
          <p className='hero-copy'>
            {t('hero.subtitle')}
          </p>

          <div className='hero-cta-wrapper'>
            <button onClick={onStartTrial} className='btn btn-primary big'>
              {t('hero.cta')}
            </button>
            <p className='hero-pricing'>
              {t('hero.pricing')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
